import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import accordion from '../../../blocks/accordion/scripts/accordion';
import collage from '../../../blocks/collage/scripts/collage';
import logoSlider from '../../../blocks/logo-slider/scripts/logo-slider';
import cAppeared from '../components/c-appeared';

gsap.registerPlugin(ScrollTrigger);

export default function () {
  accordion();
  collage();
  logoSlider();
  cAppeared();

  const careerCardsTitle = document.querySelectorAll('[data-career-cards-title]');
  careerCardsTitle.forEach((title) => {
    // eslint-disable-next-line no-new
    new SplitType(title);

    gsap.to(title.querySelectorAll('.char'), {
      y: 0,
      stagger: 0.01,
      delay: 0.1,
      duration: 0.1,
      scrollTrigger: {
        trigger: title,
        start: 'top 75%',
      },
      onComplete: () => {
        ScrollTrigger.refresh(true);
      },
    });
  });

  const careerCard = document.querySelectorAll('[data-career-card]');
  careerCard.forEach((card) => {
    gsap.from(card, {
      duration: 0.9,
      y: -40,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: card,
        start: 'top 70%',
      },
      onComplete: () => {
        ScrollTrigger.refresh(true);
      },
    });
  });

  const collageBlocks = document.querySelectorAll('[data-collage]');
  collageBlocks.forEach((collageBlock) => {
    const collageImages = collage.querySelectorAll('[data-collage-image]');

    gsap.from(collageImages, {
      duration: 0.9,
      opacity: 0,
      stagger: 0.2,
      scrollTrigger: {
        trigger: collageBlock,
        start: 'top 50%',
      },
    });
  });
}
